import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import {
  RootState,
  SHOW_LOADING,
  CLOSE_LOADING,
  SET_LOADING,
  SET_ROUTE_NAME,
  IMPORT_VALUE
} from "./types";

import $inoe from "@/config";
import router from "@/router";
import session from "@/features/session/store";
import etablissements from "@/features/etablissements/store";
import individus from "@/features/individus/store";
import information from "@/features/information/store"
import activites from "@/features/activites/store"
import pointages from "@/features/pointages/store"
import moncompte from "@/features/moncompte/store";
import parametres from "@/features/parametres/store";

import * as getters from "./getters";
import db from "@/db";
import { MobiErrorLogsDocuments } from "@/models/MobiErrorLogsDocuments";
import { utils } from "@/util";

Vue.use(Vuex);


const store: StoreOptions<RootState> = {
  state: {
    version: "1.0.0", // a simple property
    isLoading: false,
    currentRouteName: "",
    importationState: [-1, -1],
    swreg : Vue.prototype.$swreg
  },
  actions: {
    [SHOW_LOADING]({ commit }) {
      commit(SET_LOADING, true);
    },
    [CLOSE_LOADING]({ commit }) {
      commit(SET_LOADING, false);
    },
    importationProgress({ commit }, value: any) {
      commit(IMPORT_VALUE, value)
    },
    saveErrorLog({ commit }, error: string) {
      return new Promise((resolve, reject) => {
        let docError: MobiErrorLogsDocuments;
        db.getMobiErrorLogsDocuments().then((rep: any) => {
          docError = new MobiErrorLogsDocuments(rep);
        }).catch((e: any) => {
          docError = new MobiErrorLogsDocuments({});
        }).finally(() => {
          db.getDateLastSynchroMobi().then((rep2: any) => {
            docError.addNewError(utils.getCurrentTimeNow().format("DD-MM-YYYY HH:mm:ss"),
              error,
              $inoe.getUsername() || "mobiuser_unknown",
              rep2.lastExport,
              db.localDBSize);
            db.ajouterDocument(docError).then(() => resolve("done"));
          })
        })
      })
    }
  },
  getters,
  mutations: {
    [SET_LOADING](state, isLoading) {
      state.isLoading = isLoading;
    },
    [SET_ROUTE_NAME](state, name) {
      state.currentRouteName = name;
    },
    [IMPORT_VALUE](state, newVal) {
      state.importationState = newVal
    }
  },
  modules: {
    //common,
    session,
    pointages,
    etablissements,
    individus,
    information,
    activites,
    moncompte,
    parametres
  }
};
export const createStore = () => new Vuex.Store<RootState>(store);
export default createStore();
